import React from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { Box, Text, ModalBase } from '@/presentation/components'
import { configsState } from '@/presentation/pages/Settings/components'
import { isOpenSettingsDetailsState } from './atom'
import { View } from 'react-native'
import { styles } from './styles'
import { GetTickets } from '@/domain/usecases'

type ModalSettingsDetailsProps = {
}

export const ModalSettingsDetails: React.FC<ModalSettingsDetailsProps> = () => {
  const currentConfig = useRecoilValue(configsState)
  const [isOpen, setOpen] = useRecoilState(isOpenSettingsDetailsState)

  const handleClose = (): void => setOpen(false)

  return (
    <ModalBase visible={isOpen} onClose={handleClose} >
      <Box style={styles.container}>
        <View>
          <Text style={styles.titleMedium}>Condições para listar duplicatas</Text>
          <Text style={styles.bodyText}>
            Unidade permitir pagamento por cartão e ter no minimo uma forma de pagamento por cartão cadastrada.
          </Text>
          <Text style={styles.bodyText}>Ou</Text>
          <Text style={styles.bodyText}>
            A Duplicata conter o campo 'NossoNumero' e campo 'Bloqueto' preenchidos.
          </Text>
          <Text style={styles.bodyText}>
            A exibição das duplicatas é influenciado pela configuração do campo 'TempoExibirPortal'
            da tabela BancosEmpresa que é configurado em quantidade de dias
            e muda de acordo com o banco e a forma de pagamento,
            caso o valor do campo seja diferente de 0 a seguinte condição será aplicada:
            Data de Vencimento da Duplicata deve ser maior ou igual a Data atual menos o TempoExibirPortal.
          </Text>
          <Text style={styles.titleMedium}>Filtros:</Text>
          <Text style={styles.bodyText}>
            Por padrão o periodo filtrado é de {GetTickets.RN.DEFAULT_DAYS_AGO} átras
            até {GetTickets.RN.DEFAULT_DAYS_LATER} após a data atual.
          </Text>
          <Text style={styles.bodyText}>
            A data inicial do filtro pode mudar caso a configuração
            'Exibir informações Fiscais e Financeiras a partir da data' estiver ativa,
            caso a data da configuração seja mais recente que {GetTickets.RN.DEFAULT_DAYS_AGO} dias
            será utilizado a data da configuração.
          </Text>

          <Text style={styles.titleMedium}>Formas de pagamento Unidade {currentConfig?.uniCodigo}</Text>
          {currentConfig?.formasPagamento?.map(forma => {
            return <Text style={styles.bodyText}>{forma.codigo} - {forma?.descricao}</Text>
          })}
        </View>
      </Box>
    </ModalBase>
  )
}
